// Shared, axios-free date formatter consolidating the guarded en-GB timestamp duplicated in
// InventoryPage.tsx (lines ~209-221) and ShelfInventoryViewer.tsx (lines ~153-166). Produces a
// compact, unambiguous "DD Mon YYYY, hh:mm a" string, e.g. "23 Oct 2026, 11:55 PM" — short month
// name (avoids DD/MM vs MM/DD confusion) and no seconds. Empty or invalid input returns an em dash.
//
// NOTE: the InventoryPage / ShelfInventoryViewer copies are owned by a parallel workflow and are NOT
// rewired here (logic COPIED only). DraftBundleDashboard.tsx — owned by this workflow — is rewired to
// use this helper, replacing its different, unguarded `new Date(s).toLocaleString()`.
export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return '—';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};
